import { useTranslation } from "react-i18next";
import AppHandoff from "../../ui/AppHandoff";
import useDocumentTitle from "../../../hook/useDocumentTitle";

// The site root. Launchpads live at their own links (/t/{tag}, or by id), so
// someone landing here has no church in hand: point them at the link their
// church shared, or at the app.

export default function Home() {
  const { t } = useTranslation("home");
  useDocumentTitle(t("title"));

  return <AppHandoff heading={t("title")} instructions={t("subtitle")} />
}
